import { format, parse, isAfter } from 'date-fns';
import intervals from '@atlassian/jira-common-constants/src/datetimepicker-available-times.tsx';
import { formatWithLocale } from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';

function getLocalisedTimeString(intervalTime: Date, intervalString: string, userLocale?: string) {
	if (userLocale) {
		const normalizedLocale = userLocale.replace(/_/g, '-');

		return new Intl.DateTimeFormat(normalizedLocale, {
			hour: 'numeric',
			minute: 'numeric',
		}).format(intervalTime);
	}
	return intervalString;
}

export function getNext30MinuteInterval(date?: Date, userLocale?: string): string {
	// Get the current date and time
	const now = date ?? new Date();
	// Format current time to 'HH:mm'
	const currentTime = format(now, 'HH:mm');
	// Find the next interval
	for (const interval of intervals) {
		// Parse the interval time to a Date object
		const intervalTime = parse(interval, 'HH:mm', now);
		// Check if the interval is after the current time
		if (isAfter(intervalTime, now) || interval === currentTime) {
			return getLocalisedTimeString(intervalTime, interval, userLocale);
		}
	}
	const intervalTime = parse(intervals[0], 'HH:mm', now);
	// If no interval is found that is after the current time, return the first interval of the next day
	return getLocalisedTimeString(intervalTime, intervals[0], userLocale);
}

export const getFormattedDate = (userLocale: string): string => {
	return formatWithLocale(new Date(), 'P', userLocale);
};
